import BaseView from "../../../vendor_core/core/src/views/BaseView";
import WinValue from "../../../vendor_core/core/src/views/WinValue";
import App from "../../../vendor_core/core/src/App";
import { Tween } from "../../../vendor_core/core/src/Tween";
import spinModel from "../../../vendor_core/core/src/model/SpinModel";

class CustomTotalWinningsPopup extends BaseView
{


    constructor()
    {
        super();
    }


    create()
    {
        let bg = this.assets.getS9Sprite("messageBg");
        bg.width = this.layout.relWidth(40);
        bg.height = this.layout.relWidth(26);
        this.addChild(bg);
        this.layout.horizontalAlignCenter(bg, 0);
        this.layout.verticalAlignMiddle(bg, 0);

        let titleTF = this.assets.getTF(App.locale.getString("T_TotalWinning"),
            this.layout.relHeight(7));
            //TODO DECYPHER THIS v
            // this.layout.relHeight(7), "Bartho", ['#FFFFFF', '#FFFF00']);
        this.assets.addTFStroke(titleTF, {strokeColor:'#000000', strokeSize:.8});
        this.addChild(titleTF);
        this.layout.setWidth(titleTF, 80, bg);
        this.layout.horizontalAlignCenter(titleTF, 0, bg);
        this.layout.verticalAlignTop(titleTF, 10, bg);

        //TODO set winnings properly 
        // let winVal = new WinValue(this.model.getTotalWinnings(), this.config.showTotalWinningsDuration);
        let winVal = new WinValue(spinModel.winAmount, this.config.showTotalWinningsDuration);
        this.addChild(winVal);
        winVal.create();
        this.layout.setHeight(winVal, 50, bg);
        this.layout.limitSize(winVal, 200, 200, bg);
        this.layout.horizontalAlignCenter(winVal, 0, bg);
        this.layout.verticalAlignBottom(winVal, 10, bg);
        winVal.playAnimation();

        Tween.from(this, .1, {alpha:0});
        Tween.delayedCall(this.config.showTotalWinningsDuration - .25, this.hide, [], this);
    }


    hide()
    {
        Tween.to(this, .25, {alpha:0, onComplete:this.remove.bind(this)});
    }


    remove()
    {
        this.parent.removeChild(this);
    }


}

export default CustomTotalWinningsPopup
